import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import GridOnRoundedIcon from "@mui/icons-material/GridOnRounded";

/**
 * RowExportIcon
 * Single green Excel-style icon shown at the end of every Reports table row.
 * Same icon as DownloadExcelButton, used here to export/download that one row.
 */
function RowExportIcon({ row, onExport, tooltip }) {
  if (!onExport) return null;
  return (
    <Tooltip title={tooltip}>
      <IconButton size="small" onClick={() => onExport(row)}>
        <GridOnRoundedIcon fontSize="small" sx={{ color: "#1D6F42" }} />
      </IconButton>
    </Tooltip>
  );
}

RowExportIcon.propTypes = {
  row: PropTypes.object,
  onExport: PropTypes.func,
  tooltip: PropTypes.string,
};

RowExportIcon.defaultProps = {
  row: {},
  onExport: undefined,
  tooltip: "Download row",
};

export default RowExportIcon;